import React, { useEffect } from 'react';
import Hero from '../components/aboutPage/hero/Hero';
import Why from '../components/aboutPage/why/Why';
import Mission from '../components/aboutPage/Mission/Mission';
import { useParams } from 'react-router';

const CONFIG = {
  ro: {
    title: 'Metoda și ideea din spatele cursurilor',
  },
};

const AboutPage = ({ data }) => {
  const { lang } = useParams();

  useEffect(() => {
    document.title = CONFIG[lang]?.title;
  }, [lang]);

  return (
    <>
      <Hero data={data.hero} />
      <Why data={data.why} />
      <Mission data={data.mission} />
    </>
  );
};

export default AboutPage;
